import { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import "./Login.css";

const SHEET_ID = "16SugUCpwd8UOwNfs7w9qBR_to0Mo85PQiqihy06UfJg";
const GOOGLE_SHEET_JSON_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json`;

function Login({ onLogin }) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGoogleLogin = async (credentialResponse) => {
    setError("");
    setLoading(true);

    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const email = decoded.email?.toLowerCase();

      if (!email) throw new Error("No email returned from Google");

      const res = await fetch(GOOGLE_SHEET_JSON_URL);
      const text = await res.text();

      const json = JSON.parse(
        text.substring(text.indexOf("{"), text.lastIndexOf("}") + 1)
      );

      const rows = json.table.rows || [];

      const vendors = rows.map((row) => ({
        email: String(row.c[0]?.v || "").trim().toLowerCase(),
        vendor_id: String(row.c[2]?.v || "").trim(),
      }));

      const matchedVendor = vendors.find((v) => v.email === email);

      if (!matchedVendor) {
        setError("You are not authorized to access this portal");
        return;
      }

      onLogin({
        email: matchedVendor.email,
        vendor_id: matchedVendor.vendor_id,
      });
    } catch (err) {
      console.error(err);
      setError("Unable to sign in. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1>The Amaltaas Fort</h1>
          <p>Vendor Portal</p>
        </div>

        <div className="login-action">
          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={() => setError("Google sign-in failed")}
            theme="filled_blue"
            size="large"
            shape="pill"
            width="260"
          />
        </div>

        {loading && <p className="login-loading">Signing you in…</p>}
        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
}

export default Login;
